import { ReactElement } from "react";
import { Meal } from "./Meal.type";

export type MessageInteraction = 'plan-change' | 'meal-recommender';
export enum MessageSenderEnum {
    'ai' = 'ai',
    'human' = 'human'
};
export type MessageSender = MessageSenderEnum.ai | MessageSenderEnum.human;
export interface MessageWithOptions {
    answer: string;
    meals: Meal[];

}
export interface MessageOption {
    message: string | MessageWithOptions;
    sender: MessageSender;
}
export interface Message {
    type: MessageSender;
    content: string;
    options?: MessageOption[];
    component?: ReactElement;
    interaction?: MessageInteraction;
}

export interface CreateMessage {
    content: string,
    component: ReactElement,
    interaction?: MessageInteraction
}